import React from "react";
import { FadeLoader } from "react-spinners";
export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  light?: boolean;
  outlined?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, loading, light, outlined, disabled, ...props }, ref) => {
    return (
      <button
        ref={ref}
        {...props}
        disabled={disabled}
        className={`btn-primary btn h-10 rounded-none text-base font-medium capitalize disabled:cursor-not-allowed disabled:bg-primary/50 disabled:text-light ${loading && "pointer-events-none text-transparent"} ${light && "border-none bg-light hover:bg-light"} ${
          outlined &&
          "!hover:bg-transparent border border-primary !bg-transparent text-primary hover:text-primary"
        } ${className} relative ${disabled ? "cursor-not-allowed" : ""}`}
      >
        {props.children}
        {loading && (
          <div className="absolute left-0 top-0 flex h-full w-full scale-[.4] items-center justify-center">
            <FadeLoader
              color={outlined || light ? "#3366CC" : "#fff"}
              className=""
            />
          </div>
        )}
      </button>
    );
  },
);

Button.displayName = "Button";

export default Button;
